import React from "react";
import { FieldErrors, UseFormRegister } from "react-hook-form";
import { useTranslation } from "react-i18next";

type InputFieldProps = {
  label: string;
  labelRight?: React.ReactNode; // 라벨 오른쪽에 표기될 컴포넌트
  name: string;
  register: UseFormRegister<any>;
  min?: number; // type === "number" 일때 사용
  max?: number; // type === "number" 일때 사용
  errors?: FieldErrors<any>;
  title?: string;
  addClassName?: string;
  required?: boolean;
  type?: "text" | "textarea" | "number" | "date";
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

// react-hook-form을 범용적으로 사용할 Input컴포넌트
const InputField: React.FC<InputFieldProps> = ({
  label,
  labelRight,
  name,
  register,
  min,
  max,
  errors,
  title,
  addClassName,
  required = false,
  type = "text",
  onChange,
}) => {
  const { t } = useTranslation();
  const error = errors?.[name];
  return (
    <div className="form-item">
      <div className="flex justify-space-between">
        <label className="form-item-title">
          {label}
          {required && (
            <span className={`text text--${error ? "red" : "green"}`}>
              &nbsp;*
            </span>
          )}
          {/* {required && <span className="text-red-500 ml-1">*</span>} */}
        </label>
        <div>{labelRight}</div>
      </div>
      {type === "textarea" ? (
        <textarea
          {...register(name)}
          title={title}
          maxLength={256}
          className={
            error
              ? `form-control form-textbox-invalid custom-form mg mb-20 ${addClassName} form-textarea
              }`
              : `form-control custom-form ${addClassName} form-textarea
              }`
          }
        />
      ) : (
        <input
          {...register(name)}
          title={title}
          type={type}
          // maxLength={type === "textarea" ? 256 : undefined}
          min={min}
          max={max}
          onChange={onChange}
          className={
            error
              ? `form-control form-textbox-invalid custom-form mg mb-20 ${addClassName}`
              : `form-control custom-form ${addClassName}`
          }
        />
      )}

      {error && (
        <div className="mg mt--10 mb-20">
          <span className="form-invalid">{t(error?.message as string)}</span>
          {/* <span className="text-red-500 text-sm">{error?.message as string}</span> */}
        </div>
      )}
    </div>
  );
};

export default InputField;
